/**
 * Activity 3 General Form.
 *
 * Handles:
 *  - Date picker constraints to the selected site year
 *  - Custom submit buttons (JS-injected, replacing AF's native submit)
 */
const { constrain_date_pickers } = require('../helpers/_utils');

module.exports = function init_activity3_form($) {

  if (!window.acf) return;

  const settings = (typeof mlmp_settings !== 'undefined') ? mlmp_settings : {};
  const a3       = settings.activity_3 || {};
  const ctx      = settings.a3_form    || {};
  const is_edit  = !!ctx.is_edit;

  acf.addAction('ready', function () {

    const $form = $('.af-form');
    if (!$form.length) return;

    constrain_date_pickers($form, settings.site_year);

    // ── "Collected at your site?" — site context handling ─────────────────────
    // The only ways to reach this form with no site_id in the URL at all are
    // the standalone Non-Site Monarch Survival page's "Add a new record"
    // link, or editing an existing non-site record from that same page.
    // The hidden site_id field falls back to the session's currently-
    // selected site in that case (mlmp_prefill_site_id_field(),
    // functions-form-prefill.php) — when that succeeds, "Yes" stays
    // meaningfully answerable, but nothing else on the page makes it obvious
    // which site it would attach to, so show a note.
    const $site_id_input = $form.find('.acf-field[data-name="site_id"] input');
    const $collected_field = $form.find('.acf-field[data-name="collected_at_site"]');
    const has_site_context = !!($site_id_input.val() || '').trim();
    const session_site_blocked = !!ctx.session_site_name && ctx.session_site_has_site_year === false;

    if (!has_site_context && $collected_field.length) {
      // Truly no site anywhere (URL or session) — "Yes" can never go
      // anywhere, so disable the toggle outright and say so immediately.
      $collected_field.find('input[type="checkbox"]')
        .prop('disabled', true)
        .prop('checked', false)
        .trigger('change');
      $collected_field.addClass('a3-collected-at-site-disabled');
      $('<p>', {
        class: 'a3-no-site-note',
        text: a3.no_site_note || "This record isn't tied to a monitoring site, so it's saved as collected somewhere else.",
      }).appendTo($collected_field.find('.acf-input'));
    } else if (session_site_blocked && $collected_field.length) {
      // The session site exists, but has no completed annual site update
      // for this year yet — the server would reject "Yes" anyway
      // (mlmp_af_validate_a3_site_context, functions-acf-validation.php).
      // Leave the toggle interactive (not hard-disabled) so the user can
      // still try it — only then revert it and reveal the warning, rather
      // than showing the warning unprompted while it's still set to "No".
      const $checkbox = $collected_field.find('input[type="checkbox"]');
      const note_tmpl = a3.no_site_year_note || 'There is no Yearly Site Update on file for the currently selected site ({site}) and year ({year}). Please complete the {year} Yearly Site Update before selecting "Yes" here.';
      const note_text = note_tmpl
        .replace('{site}', ctx.session_site_name || '')
        .replace(/\{year\}/g, ctx.year || '');
      const $note = $('<p>', { class: 'a3-no-site-note mlmp-notice mlmp-notice-warning' })
        .text(note_text)
        .hide()
        .appendTo($collected_field.find('.acf-input'));

      $checkbox.on('change', function () {
        if (this.checked) {
          $note.show();
          $(this).prop('checked', false).trigger('change');
        }
      });
    } else if (ctx.session_site_name && $collected_field.length) {
      const $checkbox = $collected_field.find('input[type="checkbox"]');
      const note_tmpl = a3.session_site_note || 'This will be added to {site_name}.';
      const $note = $('<p>', { class: 'a3-session-site-note' })
        .text(note_tmpl.replace('{site_name}', ctx.session_site_name))
        .appendTo($collected_field.find('.acf-input'));

      function sync_session_site_note() {
        $note.toggle($checkbox.is(':checked'));
      }
      $checkbox.on('change', sync_session_site_note);
      sync_session_site_note();
    }

    // ── Custom buttons ───────────────────────────────────────────────────────
    const $intent_field  = $form.find('.acf-field[data-name="submission_intent"]');
    const $intent_input  = $intent_field.find('input');
    const $native_submit = $form.find('[type="submit"]');

    $native_submit.hide();

    function set_intent_and_submit(intent) {
      $intent_input.val(intent).trigger('change');
      $native_submit.trigger('click');
    }

    const $btn_wrap = $('<div>', { class: 'form-actions a3-form-actions' }).insertAfter($form);

    // Cancel navigates directly — never submits — so validation cannot block it.
    const cancel_url = ctx.cancel_url || '/';

    function cancel() { window.location.href = cancel_url; }

    function add_btn(label, on_click) {
      $('<button>', { type: 'button', class: 'mlmp-button-small', text: label })
        .on('click', on_click)
        .appendTo($btn_wrap);
    }

    if (is_edit) {
      add_btn(a3.btn_save || 'Save', function () {
        set_intent_and_submit('save');
      });
    } else {
      add_btn(a3.btn_save_more || 'Save and Add Another Monarch', function () {
        set_intent_and_submit('add_more');
      });

      add_btn(a3.btn_save_done || 'Save and Done', function () {
        set_intent_and_submit('save');
      });
    }

    add_btn(a3.btn_cancel || 'Cancel', cancel);

  }); // end acf ready
};
